import React, { useEffect, useState, useCallback, useRef } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import ListItem from 'jd-library/ListItem'
import styles from './action-card-click-slider.scss';
import ProductList from '../../common/product-list/ProductList';
import config from '../../../config/config';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import listing from '../../pages/listing';
import { debounceFunc } from './utils';
import { getRouteChangeMessage as getToastMessage } from '../../utills.js';

import NoProductFound from '../no-product-found/NoProductFound';
import JdCategoryCover from '../../pages/jd-category-cover/jdCategoryCover';
import { useHistory } from 'react-router-dom';
import { getListingData, reloadActionCardSlider, toggleActionCardSlider, actionCardFilter} from '../../actions/products';
import { showHideJdCatCover } from '../../actions/jdCategoryCover';
import { SliderHeader } from 'jd-library';


const ActionCardClickSlider = (props) => {
    const actionCardFilterData = useSelector(state=> state.products?.actionCardFilter)
    const { results=[] ,cardName='',filterQuery=''} = useSelector(state => state.products.actionCardData)
    const isActionCardSliderOpen  = useSelector(state => state?.session?.products?.isActionCardSliderOpen)
    const profileObj = useSelector(state => state.session.profileObject);
    const isMobile = useSelector(state => state.deviceData.isMobile)
    const [noImageText, setNoImageText] = useState('')
    const [cardNameState, setCardNameState] = useState(cardName && cardName)
    const [scroll, setScroll] = useState(0)
	const history = useHistory();
	const isReloadCardSlider =  useSelector(state=>state.products.isReloadCardSlider)
    const showCatCoverSlider = useSelector(state=>state.jdCategoryList.showCatCoverSlider)
    const getNotificationData = useSelector(state => state?.notifications?.counts);
	const dispatch = useDispatch();
    const actionSliderRef = useRef(null);

    useEffect(() => {
        if (!isMobile) {
            const timer = setTimeout(() => {
                const sliderEl = actionSliderRef.current?.sliderRef?.current?.sliderContentRef?.current;
                if (sliderEl) {
                    const firstFocusable = sliderEl.querySelector('[tabindex="0"], button:not([disabled])');
                    if (firstFocusable) firstFocusable.focus();
                }
            }, 200);
            return () => clearTimeout(timer);
        }
    }, []);

    const countForList = (filterQuery) => {
        let cnt = null
        switch (filterQuery) {
            case `&imagePresent=no`:
                cnt = getNotificationData?.imgMissingCount
                break;
            case `&specPresent=no`:
                cnt = getNotificationData?.specMissingCount
                break;
            case `&descPresent=no`:
                cnt = getNotificationData?.descMissingCount
                break;
                case `&tab=rejected`:
                cnt = getNotificationData?.rejectedCount
                break;
                case `&score=lessThanHundred`:
                cnt = getNotificationData?.scoreLessThanHundred
                break;
            default:
                break;
        }
        return cnt
    }

    useEffect(() => {
        let cnt  = countForList(filterQuery)
        if (isReloadCardSlider) {
            let toastmsg = getToastMessage();
            dispatch(getListingData({
                isFilter: true,
                filterStr: filterQuery,
                count: cnt || '',
                cb: (data) => {
                }
            }))
            dispatch(reloadActionCardSlider({ isReloadCardSlider: false }))
        }
    }, [isReloadCardSlider])

    useEffect(() => {
        if (filterQuery) {
        switch (filterQuery) {
            case '&imagePresent=no':
                setNoImageText(`No ${profileObj?.PluralLabelWithSpace} without Images Found`)
                break;
            case '&specPresent=no':
                setNoImageText(`No ${profileObj?.PluralLabelWithSpace} without Specifications Found`)
                break;
            case '&descPresent=no':
                setNoImageText(`No ${profileObj?.PluralLabelWithSpace} without Description Found`)
                break;
            case '&tab=rejected':
                setNoImageText(`No Rejected ${profileObj?.PluralLabelWithSpace} Found`)
                break;
            case '&score=lessThanHundred':
                setNoImageText(`No ${profileObj?.PluralLabelWithSpace} with Low Score Found`)
                break;
            default:
                setNoImageText(`No Data Found`)
                break;
        }
    }
    }, [filterQuery])

    const redirectToAddProduct = (selectedProductType = '') => {};
    const handleShowJdCatCover = ()=>{
		dispatch(showHideJdCatCover(false));
	}
    
    const scrollHandler = (e) => {
        if((scroll < 10 && e.target.scrollTop > 10) || e.target.scrollTop == 0){
            setScroll(e.target.scrollTop);
        }
    }

    const CardSliderWrapper = isMobile ? `div` : SliderWrapper

  const debouncedScrollHandler = debounceFunc(scrollHandler, 10);
    return (
        <>
            {isMobile && showCatCoverSlider ? 
                <JdCategoryCover
                redirectToAddProduct= {redirectToAddProduct}
                onHidden={handleShowJdCatCover}
            />
                :
                null 
            }
            { !showCatCoverSlider ? 
            <CardSliderWrapper
                ref={!isMobile ? actionSliderRef : undefined}
                header={{
                    heading: cardNameState || actionCardFilterData?.cardName,
                    className: ` ${scroll > 10 ? "header-scrolled" : ""}`
                }}
                onHidden={() => {
                        props.onHidden()
                        dispatch(actionCardFilter({ cardName: '', filterQuery: '', type: '' }))
                }}
                onScroll={debouncedScrollHandler}
            >
                {isMobile && <SliderHeader
                className= {` ${scroll > 10 ? "header-scrolled" : ""}`}
                heading={cardNameState || actionCardFilterData?.cardName}
                leftIcons={
                    (isMobile || props.sliderName?.fromNotification) ? [
                            {
                                className: 'icon-hdrBackNew',
                                onClick: () => {
                                    dispatch(reloadActionCardSlider({ isReloadCardSlider: false }))
                                    dispatch(toggleActionCardSlider({isActionCardSliderOpen: false}))
                                    dispatch(actionCardFilter({ cardName: '', filterQuery: '', type: '' }))
                                    history.goBack();
                                }
                            }
                        ] : []
                }
                variant="secondary"
              />}              
                {results.length ? 
                 <div className={'list-item-wrapper'}>
                    <div className={`${styles['search-holder']} ${'web-page'}`} >
                        <ProductList
                            {...props}
                            products={results}
                            isFromActionCard={true}
                        />
                    </div>
                </div>
                : 
                <NoProductFound
                    label={noImageText}
                />
                }
            </CardSliderWrapper> : null}
        </>
    )
}

export default ActionCardClickSlider